import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('TournamentReward')
export class TournamentReward {

  @JsonProperty('range_min', Number)
  rangeMin: number = 1;

  @JsonProperty('range_max', Number)
  rangeMax: number = 1;

  @JsonProperty('reward_quantity', Number)
  rewardQuantity: number = 0;
}
